module.exports = __webpack_public_path__ + "static/img/gaozhongdili8.f1387d57.jpg";